import { render } from "./TableItem.vue?vue&type=template&id=1beb2612&scoped=true&ts=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"

import "./TableItem.vue?vue&type=style&index=0&id=1beb2612&scoped=true&lang=css"

import exportComponent from "F:\\hotaru_theme_for_RustVersion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1beb2612"]])

export default __exports__